/**
 * WP-621 (grounding S1, Copilot review PR #599): the server's `degradedPreloads` marker
 * (convex/agentKnowledge/orientPreloadFallbacks.ts) named which task preload(s) fell back to a
 * typed-empty default this run — but it was served only on the raw Convex view, never rendered
 * by either connector, so a degraded run silently looked like a normal thinner result
 * (undermining "serve less, LABELLED"). Offset extraction out of tools/orient.ts (STD-2/
 * DEC-1504 shrink-only budget) — one shared line-builder for both the brief and full text
 * renderers.
 */
export function buildDegradedPreloadsLine(degraded?: readonly string[] | null): string | null {
  if (!degraded || degraded.length === 0) return null;
  return `⚠️ Degraded this run: ${degraded.join(", ")} preload(s) failed open — results may be thinner than usual.`;
}

/**
 * WP-485 Slice 1 review fix (Codex P2, PR #367, "Render coherency status on the MCP orient
 * surface"): mirrors packages/cli/src/formatters/orientDegradation.ts's own coherencyCheckTag —
 * the CLI formatter surfaced this per-bet marker, but the MCP orient tool never rendered it, so
 * an MCP agent saw silent-clean for a bet whose latest contradiction-detection status is
 * partial/unavailable/never-run. coherence-run-sweep fix (PR #423, Codex P2): TEN-2746 §2c added
 * a THIRD status, 'stale' — an MCP agent (the surface that actually performs `updateEntry`) saw
 * a stale active work package fall through to the empty-string branch and render as silently
 * fresh. Relocated here (STD-2/DEC-1504 shrink-only offset, WP-621 S1).
 */
export function coherencyCheckTag(status: "not_checked" | "check_incomplete" | "stale" | undefined): string {
  if (status === "not_checked") return " [not checked]";
  if (status === "check_incomplete") return " [check incomplete]";
  if (status === "stale") return " [stale — entry changed since last check]";
  return "";
}
